export const MenuItems = [
  {
    title: "Home",
    url: "/",
    cName: "nav-list-item-container",
    loggedOut: null,
  },
  {
    title: "Dashboard",
    url: "/dashboard",
    cName: "nav-list-item-container",
    loggedOut: null,
  },
  {
    title: "About",
    url: "/about",
    cName: "nav-list-item-container",
    loggedOut: null,
  },
  {
    title: "Contact",
    url: "/contact",
    cName: "nav-list-item-container",
    loggedOut: null,
  },
  {
    title: "Login",
    url: "/login",
    cName: "nav-list-item-container",
    loggedOut: true,
  },
  {
    title: "Sign Up",
    url: "/signup",
    cName: "nav-list-item-container nav-list-item-container-signup",
    loggedOut: true,
  },
  {
    title: "Profile",
    url: "/profile",
    cName: "nav-list-item-container nav-list-item-container-last",
    loggedOut: false,
  },
];
